// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2_KpO","info":"UpdateTermsInfo_info__MI3Bs"};